import { setInitialState } from "../../../../utils/reducerOperations";
export function Default() {
    return {
        addReminderApi: setInitialState(),
        editReminderApi: setInitialState(),
        listReminderApi: setInitialState(),
    };
}
